import { CreateNS } from '../lib/createAPIBuilder';

export const installAPISplashScreen = (namespace: CreateNS) => {
    namespace('splashScreen')(({ func, deps }) => {
        func('remove', deps.removeSplashScreen);
    });
};
